import { CurrencyDirective } from 'vue-currency-input'

export default {
	directives: { currency: CurrencyDirective },
	data: () => ({
		money: {
			currency: 'USD',
			locale: 'en',
			autoDecimalMode: true,
			distractionFree: false
		}
	}),
}
